export const EXTRA_ACTIVITY_NAMES = [
  "Arts and Crafts",
  "Bingo",
  "In House Game",
];

export const mergeActivityNames = (names) =>
  Array.from(
    new Set([
      ...(Array.isArray(names) ? names.filter(Boolean) : []),
      ...EXTRA_ACTIVITY_NAMES,
    ])
  );
